import {BINData, BinDataResponse, ValidationStatus} from './types';

export const getBINData = (value: string, binData?: BinDataResponse): BINData | undefined => {
  if (value && typeof value === 'string') {
    const _value = value.split(' ').join('');
    if (_value.length > 6) {
      const basicBinData: BINData = {
        bin: _value.slice(0, 6),
        last4: _value.slice(_value.length - 4),
      };

      if (binData && binData.card_bin_info && binData.card_bin_info[0]) {
        Object.assign(basicBinData, binData.card_bin_info[0]);

        if (binData.verification_info && binData.verification_info.rule_id) {
          basicBinData.verificationInfo = {
            rule_id: binData.verification_info.rule_id,
            verification_control: binData.verification_info.verification_control,
          };
        }
      }

      return basicBinData;
    }
  }
};

/**
 * Validates verification rules based on BIN data
 * @param validation - The current validation status object
 * @param binData - BIN data containing verification information (can be either BINData or BinDataResponse)
 * @returns void - modifies the validation object in place
 */
export const validateVerificationRule = (validation: ValidationStatus, binData?: BinDataResponse | BINData): void => {
  // If BIN data is not available, skip verification rule validation
  if (!binData) return;

  // Handle BinDataResponse type
  if ('verification_info' in binData && binData.verification_info) {
    if (binData.verification_info.verification_control === 'Decline Payment') {
      validation.isValid = false;
      validation.error = 'error.validation.cardCommonDeclineReason';
    }
    return;
  }

  // Handle BINData type
  if ('verificationInfo' in binData && binData.verificationInfo) {
    if (binData.verificationInfo.verification_control === 'Decline Payment') {
      validation.isValid = false;
      validation.error = 'error.validation.cardCommonDeclineReason';
    }
    return;
  }
};
